import React from 'react';
import { TableCell, FormLabel, TableRow, FormControl } from '@material-ui/core';
import { ProcessingTypeEnum } from '../inputs/ProcessingTypeSelectFormik';
import CommonContainer from '../../containers/Common';
import { RxOrder } from 'openapi';
import { DegreeTypeEnum } from '../inputs/DegreeTypeSelectFormik';
import { useTranslation } from 'react-i18next';

interface Props {
    rowData: RxOrder,
}

export const ProcessingText: React.FC<Props> = ({ rowData }) => {
    const {t} = useTranslation();

    const commonContainer = CommonContainer.useContainer();
    const frame = commonContainer.getFrameByFrameMasterId(rowData.meganetFrameMasterId);

    return (
        <TableRow>
            <TableCell>
                <FormControl>
                    <FormLabel id='rightPd' style={{ fontSize: 13, }}>{t('processing')}</FormLabel>
                    <br />
                    <FormLabel id='rightPd' style={{ color: 'black' }}>{t(ProcessingTypeEnum[rowData.processingType])}</FormLabel>
                </FormControl>
            </TableCell>
            {rowData.processingType === ProcessingTypeEnum.Maker &&
            <>
                <TableCell>
                    <FormControl>
                        <FormLabel id='rightPd' style={{ fontSize: 13, }}>{t('frame')}</FormLabel>
                        <br />
                        <FormLabel id='rightPd' style={{ color: 'black' }}>{frame?.frameName ? frame?.frameName : '対象外'}</FormLabel>
                    </FormControl>
                </TableCell>
                <TableCell>
                    <FormControl>
                        <FormLabel id='degreeType' style={{ fontSize: 13, }}>{t('degreeType')}</FormLabel>
                        <br />
                        <FormLabel id='degreeType' style={{ color: 'black' }}>
                            {
                                rowData.degreeType === DegreeTypeEnum.遠用 ? "遠用" : 
                                rowData.degreeType === DegreeTypeEnum.近用 ? "近用" : "両用"
                            }
                        </FormLabel>
                    </FormControl>
                </TableCell>
                <TableCell align='right'>
                    <FormControl>
                        <FormLabel id='leftPd' style={{ fontSize: 13, }}>{`${t('left')} ${t('pd')}`}</FormLabel>
                        <br />
                        <FormLabel id='leftPd' style={{ color: 'black' }}>{rowData.leftPd?.toFixed(2)}</FormLabel>
                    </FormControl>
                </TableCell>
                <TableCell align='right'>
                    <FormControl>
                        <FormLabel id='leftHeight' style={{ fontSize: 13, }}>{`${t('left')} ${t('ep')}`}</FormLabel>
                        <br />
                        <FormLabel id='leftHeight' style={{ color: 'black' }}>
                            {rowData.degreeType === DegreeTypeEnum.遠用 ? 2 : 
                             rowData.degreeType === DegreeTypeEnum.近用 ? 0 :
                             rowData.leftHeight?.toFixed(2)}
                        </FormLabel>
                    </FormControl>
                </TableCell>
                <TableCell align='right'>
                    <FormControl>
                        <FormLabel id='rightPd' style={{ fontSize: 13, }}>{`${t('right')} ${t('pd')}`}</FormLabel>
                        <br />
                        <FormLabel id='rightPd' style={{ color: 'black' }}>{rowData.rightPd?.toFixed(2)}</FormLabel>
                    </FormControl>
                </TableCell>
                <TableCell align='right'>
                    <FormControl>
                        <FormLabel id='rightHeight' style={{ fontSize: 13, }}>{`${t('right')} ${t('ep')}`}</FormLabel>
                        <br />
                        <FormLabel id='rightHeight' style={{ color: 'black' }}>
                            {rowData.degreeType === DegreeTypeEnum.遠用 ? 2 : 
                             rowData.degreeType === DegreeTypeEnum.近用 ? 0 :
                             rowData.rightHeight?.toFixed(2)}
                        </FormLabel>
                    </FormControl>
                </TableCell>
            </>
            }
        </TableRow>
    );
}

export default ProcessingText;